export default __webpack_public_path__ + "static/media/jezus.7dd38396.jpg";